<template>
  <div>
    <correios-declaracao
      v-if="isCorreios(order.service.company.id)"
      :order="order"
    />
    <jadlog-declaracao
      v-if="isJadlog(order.service.company.id)"
      :order="order"
    />
    <latam-declaracao
      v-if="isLATAMCargo(order.service.company.id)"
      :order="order"
    />
    <azulcargo-declaracao
      v-if="isAzulCargoExpress(order.service.company.id)"
      :order="order"
    />
    <buslog-declaracao
      v-if="isBuslog(order.service.company.id)"
      :order="order"
    />
    <loggi-declaracao
      v-if="isLoggi(order.service.company.id)"
      :order="order"
    />
    <jet-declaracao
      v-if="isJET(order.service.company.id)"
      :order="order"
    />
  </div>
</template>

<script>
  import CorreiosDeclaracao from 'commons/js/components/print/CorreiosDeclaracao.vue';
  import JadlogDeclaracao from 'commons/js/components/print/JadlogDeclaracao.vue';
  import LatamCargoDeclaracao from 'commons/js/components/print/LatamCargoDeclaracao.vue';
  import AzulCargoDeclaracao from 'commons/js/components/print/AzulCargoDeclaracao.vue';
  import BuslogDeclaracao from 'commons/js/components/print/BuslogDeclaracao.vue';
  import LoggiDeclaracao from 'commons/js/components/print/LoggiDeclaracao.vue';
  import JETDeclaracao from 'commons/js/components/print/JETDeclaracao.vue';
  import ShippingDefinitions from 'commons/js/ShippingDefinitions';

  export default {
    mixins: [ShippingDefinitions],

    components: {
      'correios-declaracao': CorreiosDeclaracao,
      'jadlog-declaracao': JadlogDeclaracao,
      'latam-declaracao': LatamCargoDeclaracao,
      'azulcargo-declaracao': AzulCargoDeclaracao,
      'buslog-declaracao': BuslogDeclaracao,
      'loggi-declaracao': LoggiDeclaracao,
      'jet-declaracao': JETDeclaracao,
    },

    props: {
      order: {
        type: Object,
        required: true
      },
    },
  }
</script>
